var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('popup', {
    attrs: {
      "opened": _vm.opened
    },
    on: {
      "close": _vm.close
    }
  }, [_c('div', {
    staticClass: "mx-5 xl:mx-16 2xl:mx-20 my-8 w-auto h-auto"
  }, [_c('h3', {
    staticClass: "text-pink-600 mb-10"
  }, [_vm._v("Compte activé !")]), _vm._v(" "), _c('div', {
    staticClass: "text-center text-lg text-indigo-600 mb-10"
  }, [_c('p', [_vm._v("Votre compte a bien été activé.")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.user.is_particulier ? "Vous pouvez dès à présent, utiliser Neopass." : "Vous pouvez dès à présent utiliser l'application Neopass."))]), _vm._v(" "), _c('br'), _vm._v(" "), _vm.$trial() ? _c('p', [_vm._v("La version d'essai est valable pour une durée de 15 jours."), _c('br'), _vm._v(" Elle vous permet d'accéder à tous les modules et de créer un carnet de parcours.")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "w-full flex justify-center"
  }, [_c('illustration', {
    staticClass: "w-full",
    attrs: {
      "name": "basket"
    }
  })], 1)])]);

}
var staticRenderFns = []

export { render, staticRenderFns }